import { useParams } from "react-router-dom";
import { NotFound } from './404';
import { langNames, specialDesc, fontName, romanNumerals } from "../funcs";
import { Link } from 'react-router-dom';
import { Chara } from "../types/Dict";
import { PhunChara } from "./phunChara";

import { useContext } from "react";
import { dictContext } from "../App";

import reactStringReplace from "react-string-replace";

export const CharaPage = () => {
    const params = useParams();
    const charaID = params.id

    const dict = useContext(dictContext)
    const matchData: any = dict.find(v => v.id == charaID)

    if (matchData !== undefined) {
        const prev = <PrevButton dict={dict} id={charaID}/>
        const next = <NextButton dict={dict} id={charaID}/>

        return (
            <div className='pageWrapper'>
                <CharaInfo data={matchData} prev={prev} next={next}/>
                <CharaLangs data={matchData} dict={dict}/>
            </div>
        )
    } else {
        return <NotFound />
    }
}

const CharaInfo = (props: any) => {
    const data: any = props.data

    return (
        <div className='info'>
            <div className="moveLink">
                {props.prev}
                {props.next}
            </div>
            <div className='charaFrame'>
                <span className='mainChara'>
                    <PhunChara>{data?.chara}</PhunChara>
                </span>
            </div>
            <div><span className='kanji serif'>{data?.chara}</span></div>
            <table className='dataTable'>
                <tbody>
                    <tr>
                        <th>PhunID</th>
                        <td>{data.id}</td>
                    </tr>
                    <tr>
                        <th>画数</th>
                        <td>{data.strokes}</td>
                    </tr>
                    <tr>
                        <th>部首</th>
                        <td>{data.radical}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

const CharaLangs = (props: {data: Chara, dict: Chara[]}) => {
    const data = props.data.langs
    return (
        <div className='langs'>
            <div className='langData'>
                <h2>字構成</h2>
                <div className='charaStructure'>
                    <CharaStructure char={props.data.chara} dict={props.dict} depth={1}/>
                </div>
            </div>
            {props.data.origin && <div className='langData'>
                <h2>字源</h2>
                <p>
                    {reactStringReplace(props.data.origin, /\[(.*?)\]/g, (match) => 
                        (<a href={`/chara/${props.dict.find(e => e.chara == match)?.id}`} target="_blank">
                            <span className="serif">{match}</span>
                        </a>)
                    )}
                </p>
            </div>}
            
            {Object.keys(data).map((v) => {
                const setLink = (links?: {name: string; url: string;}[]) => {
                    if (!links) { return <></> }
                    return (
                        <div className="langLinks">
                            {links.map((l: any, idx: number) =>
                                <span><a href={l.url} key={idx}>{l.name}</a></span>
                            )}
                        </div>
                    )
                }
                
                return (
                <div className='langData' key={v}>
                    <h2>{langNames[v]}</h2>
                    {data[v].map((word, idx) =>
                        <div key={idx}>
                            {data[v].length > 1 && <h3>{idx + 1}.</h3>}
                            <div className="dataRow">
                                <div className="dataLabel">読み</div>
                                <div className="data">{word.pron}</div>
                            </div>
                            {word.mean && <div className="dataRow">
                                <div className="dataLabel">字義</div>
                                <div className="data">{word.mean}</div>
                            </div>}
                            {word.etymology && <div className="dataRow">
                                <div className="dataLabel">語源</div>
                                <div className="data">{word.etymology}</div>
                            </div>}
                            {setLink(word.links)}
                        </div>
                    )}
                </div>)
            })}

            {props.data.support[0] && <div className='langData'>
                <h2>字形</h2>
                <div className="charaFontBox">
                    {props.data.support.map(s => <div className="charaFont" key={s}>
                        <span className={`fontName ${s}`}>{props.data.chara}</span>
                        <span className="fontNameLabel">{fontName[s]}</span>
                    </div>)}
                </div>
            </div>}
        </div>
    )
}

const PrevButton = (props: any) => {
    const data = props.dict.find((e: any) => e.id == Number(props.id) - 1)
    return data
        ? <div className="prevButton">
            <Link to={`/chara/${data.id}`}>
                {`< `}
                <PhunChara>{data.chara}</PhunChara>
            </Link>
        </div>
        : <div className="prevButton disabled">
            <span>{`< -`}</span>
        </div>
}

const NextButton = (props: any) => {
    const data = props.dict.find((e: any) => e.id == Number(props.id) + 1)
    return data
        ? <div className="nextButton">
            <Link to={`/chara/${data.id}`}>
                <PhunChara>{data.chara}</PhunChara>
                {` >`}
            </Link>
        </div>
        : <div className="nextButton disabled">
            <span>{`- >`}</span>
        </div>
}

const CharaStructure = (props: {char: string, dict: Chara[], modified?: boolean, depth: number}) => {
    if (props.depth > 10) {return <div className="treeNode">Error: 無限再帰</div>}

    const charData = props.dict.find(c => c.chara == props.char)
    if (!charData) {
        return <div className="treeNode">?</div>
    }
    if (charData.structure.type == "radical") {
        return <div className={`treeNode ${props.modified ?"modified" :""}`}>
            <NodeChara char={charData.chara} id={charData.id}/>
        </div>
    }

    const nodes = charData.parts.map(r => {
        if (r.special) {
            return <div className="treeNode specialDesc serif">({specialDesc[r.char]})</div>
        }
        return <CharaStructure char={r.char} dict={props.dict} depth={props.depth + 1} modified={r.modify ?true :false}/>
    })

    return <div className={`treeNode ${props.modified ?"modified" :""}`}>
        <NodeChara char={charData.chara} id={charData.id}/>
        <div className="nodeRow">{nodes}</div>
    </div>
}

const NodeChara = (props: {char: string, id: string}) => {
    return <div>
        <Link to={`/chara/${props.id}`}>
            <span className="nodeChara">
                <PhunChara>{props.char}</PhunChara>
                <span className="serif nodeKanji">{props.char}</span>
            </span>
        </Link>
    </div>
}